import React from "react";
import { useParams } from "react-router-dom";
import ReactHtmlParser from "react-html-parser";
import { useQuery } from "@apollo/client";
import Helmet from "../../common/components/helmet";
import GenericError from "../../common/components/generic-error";
import GET_PAGE_CONTENT from "./gql";

import "./index.scss";

const Page = () => {
  const { pageId } = useParams();
  const { loading, error, data } = useQuery(GET_PAGE_CONTENT, {
    variables: { id: pageId },
  });

  if (loading) return null;
  if (error || !data || !data?.page) {
    console.log(error);
    return <GenericError />;
  }

  const { page } = data;

  return (
    <div>
      <Helmet seo={page?.seo} />
      <section className="title-banner">
        <h1>{page?.title}</h1>
      </section>
      <section className="custom-page-content">
        {ReactHtmlParser(page?.content?.html)}
      </section>
    </div>
  );
};

export default Page;
